/**
 * Localisation (§12).
 *
 * Czech is the default; English is complete. The backend never sends a
 * sentence — it sends stable codes — so every string a user reads lives here.
 */

import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import { cs } from './cs';
import { en } from './en';

export const SUPPORTED_LANGUAGES = ['cs', 'en'] as const;
export type Language = (typeof SUPPORTED_LANGUAGES)[number];

const STORAGE_KEY = 'usolar.language';

function initialLanguage(): Language {
  // The product default is Czech (§12). A stored choice wins; the browser
  // language is only consulted for languages we actually ship, so a visitor
  // with an unrelated locale still lands on Czech rather than English.
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored && (SUPPORTED_LANGUAGES as readonly string[]).includes(stored)) {
    return stored as Language;
  }
  return 'cs';
}

void i18next.use(initReactI18next).init({
  resources: { cs: { translation: cs }, en: { translation: en } },
  lng: initialLanguage(),
  fallbackLng: 'cs',
  interpolation: { escapeValue: false },
});

export function setLanguage(language: Language): void {
  localStorage.setItem(STORAGE_KEY, language);
  void i18next.changeLanguage(language);
  document.documentElement.lang = language;
}

document.documentElement.lang = i18next.language;

export default i18next;
